import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BuyFlowUser } from "features/types";
interface InitialState {
  adultMemberQuantity: number;
  childMemberQuantity: number;
  newMembers: BuyFlowUser[];
}

const initialState: InitialState = {
  adultMemberQuantity: 1,
  childMemberQuantity: 0,
  newMembers: [],
};
const addMembershipFlowSlice = createSlice({
  name: "addMembershipFlow",
  initialState,
  reducers: {
    reduceAdultMemberQuantity: (state) => {
      if (state.adultMemberQuantity === 0) return;
      state.adultMemberQuantity = state.adultMemberQuantity - 1;
    },
    increaseAdultMemberQuantity: (state) => {
      state.adultMemberQuantity = state.adultMemberQuantity + 1;
    },
    reduceChildMemberQuantity: (state) => {
      if (state.childMemberQuantity === 0) return;
      state.childMemberQuantity = state.childMemberQuantity - 1;
    },
    increaseChildMemberQuantity: (state) => {
      state.childMemberQuantity = state.childMemberQuantity + 1;
    },
    setAdultMemberQuantity: (state, action: PayloadAction<number>) => {
      state.adultMemberQuantity = action.payload;
    },
    setChildMemberQuantity: (state, action: PayloadAction<number>) => {
      state.childMemberQuantity = action.payload;
    },
    setNewMembers: (state, action: PayloadAction<BuyFlowUser[]>) => {
      state.newMembers = action.payload;
    },
    resetAddMembershipFlow: () => initialState,
  },
});

export const {
  reduceAdultMemberQuantity,
  increaseAdultMemberQuantity,
  reduceChildMemberQuantity,
  increaseChildMemberQuantity,
  setAdultMemberQuantity,
  setChildMemberQuantity,
  setNewMembers,
  resetAddMembershipFlow,
} = addMembershipFlowSlice.actions;

export default addMembershipFlowSlice.reducer;
